<template>
  <div class="c-echart">
    <pip-role v-bind="$attrs" />
    <pip-role-level v-bind="$attrs" />
    <pip-active v-bind="$attrs" />
  </div>
</template>
<script>
import PipRole from './pip-evaluate'
import PipRoleLevel from './pip-role-level'
import PipActive from './pip-recongise'
export default {
  name: 'UserEchartPip',
  components: { PipRole, PipActive, PipRoleLevel }
}
</script>
<style lang="scss" scoped>
.c-echart {
  width: 100%;
  height: 320px;
  display: flex;
}
</style>
